// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"DoughnutChart_chartContainer__2er5Z"};